import React from 'react';
export const DemoBadge = ({ testid }) => <span className="keno-demo-badge account-demo-badge" data-testid={testid}>Demo</span>;